
.form {
  display: flex;
  flex-direction: column;
}

.form label {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: stretch;
  min-width: 0;
  width: 100%;
}

.loader {
  height: 50vh;
}

.form input, .form select {
  background-color: var(--secondary-enabled);
  color: var(--static-text-strong, #1a1a1a);
  border: 1px solid var(--static-divider-standard);
  border-radius: 8px;
  padding: 0.25rem 0.75rem;
  font-family: inherit;
  height: 2.5rem;
  width: 100%;
}

.form input::placeholder {
  color: var(--static-text-weak);
}

.form select {
  min-width: 0;
}

.submitButton {
  margin: 1.5rem 0;
}

.navigate {
  display: flex;
  justify-content: center;
  gap: 0.5rem;
}

.encrypted {
  display: flex;
  gap: 0.75rem;
  align-items: center;
}

.divider {
  background-color: var(--static-divider-standard);
  height: 1px;
  width: 100%;
  margin: 1.5rem 0;
}

.space {
  padding-bottom: 1rem;
}

.row {
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 1rem;
}

.col {
  display: flex;
  flex-direction: column;
  flex-basis: 50%;
}